import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

// Create the context
const AuthContext = createContext();

// Standard AuthProvider using children instead of Component
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(Cookies.get('token') || null);

  // Save token to cookies
  const setTokenInCookies = (token) => {
    Cookies.set('token', token, { expires: 7 });
  };

  // Set a new token (in state + cookies)
  const setNewToken = (newToken) => {
    setToken(newToken);
    setTokenInCookies(newToken);
  };

  // Clear token from state + cookies
  const clearToken = () => {
    setToken(null);
    Cookies.remove('token');
  };

  // Load token from cookies on first render
  useEffect(() => {
    const tokenFromCookies = Cookies.get('token');
    if (tokenFromCookies) {
      setToken(tokenFromCookies);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ setToken: setNewToken, clearToken, token }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
